import React, { Component, Fragment } from 'react';
import { func, string } from 'prop-types';
import { TextField, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { Button } from '../../Button';
import IntlMessages from '../../../util/IntlMessages';
import { AUTH_ERROR_TYPES } from '../../../constants/Values';

/**
 * Represents stateless functional component IdentifierForm
 * Asks user to enter either phone number or email which will become an identifier
 * @param {object} props Component props
 * @param {String} props.identifier Represents user login
 * @param {function} props.onFieldChange Password change callback function
 * @param {function} props.showAuthLoader Shows form loader if form is submitted
 * @param {function} props.verifyUser Dispatches an action of a specific type if form is submitted
 * @return {Component}
 * */
class IdentifierForm extends Component {
  static propTypes = {
    errorMessage: string,
    identifier: string,
    onFieldChange: func,
    resetErrorMessage: func,
    showAuthLoader: func,
    verifyUser: func,
  };

  static defaultProps = {
    errorMessage: '',
    identifier: '',
    onFieldChange: () => {},
    resetErrorMessage: () => {},
    showAuthLoader: () => {},
    verifyUser: () => {},
  };

  shouldComponentUpdate(nextProps) {
    return (
      nextProps.identifier !== this.props.identifier ||
      nextProps.errorMessage !== this.props.errorMessage
    );
  }

  componentWillUnmount() {
    if (this.props.errorMessage) {
      this.props.resetErrorMessage(AUTH_ERROR_TYPES.IDENTIFIER);
    }
  }

  onFormSubmit = event => {
    event.preventDefault();

    if (!this.props.identifier) {
      return;
    }

    this.verifyUser();
  };

  handleFieldChange = event => this.props.onFieldChange(event.target.id, event.target.value);

  verifyUser = () => {
    this.props.showAuthLoader();
    this.props.verifyUser();
  };

  render() {
    return (
      <Fragment>
        <Box className="app-login-header" sx={{ mb: 3 }}>
          <h2>
            <IntlMessages id="auth.identifier.header" />
          </h2>
        </Box>
        <div className="app-login-form">
          <form onSubmit={this.onFormSubmit}>
            <fieldset>
              <TextField
                autoFocus
                sx={{ mt: { xs: 1, sm: 3 }, mb: { xs: 1, sm: 3 } }}
                defaultValue={this.props.identifier}
                error={!!this.props.errorMessage}
                fullWidth
                helperText={
                  this.props.errorMessage || <IntlMessages id="auth.identifier.helperText" />
                }
                id="identifier"
                label={<IntlMessages id="auth.identifier.label" />}
                margin="normal"
                onChange={this.handleFieldChange}
              />
              <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Link to="/reset-password">
                  <IntlMessages id="appModule.forgotPassword" />
                </Link>

                <Button
                  size="large"
                  labelId="auth.identifier.buttonText"
                  color="primary"
                  disabled={!this.props.identifier}
                  type="submit"
                  variant="contained"
                />
              </Box>
            </fieldset>
          </form>
        </div>
      </Fragment>
    );
  }
}

export default IdentifierForm;
